import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const ResetLimitsSkeleton = () => (
    <Group>
        <SkeletonItem width={156} height={32}/>
        <SkeletonItem width={400} height={18}/>
    </Group>
);
